import { Box, Typography } from '@mui/material';

import type { ReactNode } from 'react';

interface DetailProps {
  children: ReactNode;
}

const Detail: React.FC<DetailProps> = ({ children }: DetailProps) => (
  <Box component='dd' sx={{ color: 'typography.light', m: 0, minWidth: 0 }}>
    <Typography variant='p3' sx={{ overflowWrap: 'anywhere' }}>
      {children}
    </Typography>
  </Box>
);

export default Detail;
